import React, { useEffect, useRef, useState } from "react";
import styles from "./index.module.scss";
import VideoPlayer from "../../../VideoPlayer";
import cn from "classnames";
import { track } from "../../../../../../utils/amplitude";
import DownloadScreensModal from "../../../../modal/DownloadScreensModal";

export default function Content(props) {
  const { data, version, fullImg, fullImgState } = props;
  const [image, setImage] = useState(null);
  const [stopVideo, setStopVideo] = useState(false);
  const [onbourdingFilter, setOnboardingFilter] = useState([]);
  const [paywalsFilter, setPaywalsFilter] = useState([]);
  const scrollRef = useRef();
  const [showModal, setShowModal] = useState(false);

  const dataObj = [
    version?.paywalls_images,
    {
      src: version?.video_url.thumb,
      type: "video",
      id: "video",
      url: version?.preview.thumb,
    },

    version?.onboard_images,
  ];
  const filterFunk = () => {
    let filterArrPaywall = [];
    let filterArrOnboard = [];
    version?.onboard_images.map((el) => {
      if (filterArrOnboard.indexOf(el.id) === -1) {
        filterArrOnboard = [...filterArrOnboard, el];
      }
    });

    version?.paywalls_images.map((el) => {
      if (filterArrPaywall.indexOf(el.id) === -1) {
        filterArrPaywall = [...filterArrPaywall, el];
      }
    });
    setPaywalsFilter(filterArrPaywall);
    setOnboardingFilter(filterArrOnboard);
  };
  useEffect(() => {
    if (version?.paywalls_images?.length) {
      setImage(version.paywalls_images[0]);
    }
  }, [version]);

  useEffect(() => {
    if (!fullImgState) setStopVideo(false);
  }, [fullImgState]);

  useEffect(() => {
    scrollRef.current.scrollIntoView({ behavior: "smooth" });
  }, [image]);

  useEffect(() => {
    filterFunk();
  }, []);

  const imgClickFunck = () => {
    if (!stopVideo) setStopVideo(true);
    let key;
    if (image.identef === "video") {
      key = version?.paywalls_images?.length;
    } else if (image.identef === "onboarding") {
      key = version?.paywalls_images?.length + image.key + 1;
    } else {
      key = image?.key ? image?.key : 0;
    }
    fullImg({
      key: key,
      data: dataObj,
    });
    document.body.style.overflow = "hidden";
  };

  return (
    <>
      <div className={styles.root} ref={scrollRef}>
        <div className={styles.heading}>
          <div className={styles.title}>
            <div className={styles.icon}>
              <img
                width="32"
                height="32"
                src={data.icon_url}
                loading="lazy"
                alt="alt"
              />
            </div>
            <h1>{data.name}</h1>
          </div>
          <div className={styles.title}>
            <div className={styles.action_wrapper}>
              {/*<Button*/}
              {/*  title="Download all screens"*/}
              {/*  onClick={() => setShowModal(true)}*/}
              {/*/>*/}
              <a
                href={data.store_url}
                target="_blank"
                onClick={() =>
                  track("paywall_gallery_item_view_in_store_link_clicked")
                }
              >
                View in Store
              </a>
            </div>
          </div>
        </div>
        {version && (
          <div className={styles.gallery}>
            {image && (
              <div className={styles.image}>
                <div className={styles.wrapper}>
                  {image.type === "video" ? (
                    <div onClick={imgClickFunck}>
                      <VideoPlayer
                        src={image?.url.thumb}
                        on
                        stopVideo={stopVideo}
                        img={image.img}
                      />
                    </div>
                  ) : (
                    <img
                      src={image.url?.thumb}
                      height="604"
                      width="280"
                      loading="lazy"
                      onClick={imgClickFunck}
                      alt="alt"
                    />
                  )}
                  <div className={styles.actions}>
                    <a
                      href={
                        image.type === "video"
                          ? image.url.original
                          : image.url?.thumb
                      }
                      className={styles.download}
                      download
                      target="_blank"
                      onClick={() => {
                        track("paywall_gallery_item_download_link_clicked");
                      }}
                    >
                      Download
                    </a>
                  </div>
                </div>
              </div>
            )}
            <div className={styles.tiles}>
              <div className={styles.group}>
                <label>Paywalls</label>
                <ul>
                  {/* {version?.paywalls_images.map((img, key, i) => ( */}
                  {paywalsFilter.map((img, key, i) => (
                    <li
                      className={`${image?.id === img.id && styles.active} `}
                      key={key}
                      onClick={() => setImage({ ...img, key })}
                    >
                      <img
                        src={img.url.small}
                        width="58"
                        height="144"
                        loading="lazy"
                        alt="alt"
                      />
                    </li>
                  ))}
                </ul>
              </div>
              <div className={styles.group}>
                <label>Onboarding</label>
                <ul>
                  <li
                    className={cn(`${image?.id === "video" && styles.active}`)}
                    onClick={() =>
                      setImage({
                        url: version.video_url,
                        type: "video",
                        id: "video",
                        key: 0,
                        identef: "video",
                        img: version.preview.thumb,
                      })
                    }
                  >
                    <img
                      src={version.preview.small}
                      width="58"
                      height="144"
                      loading="lazy"
                      alt="alt"
                    />
                    <div className={styles.play}></div>
                  </li>
                  {/* {version?.onboard_images.map((img, key) => ( */}
                  {onbourdingFilter.map((img, key) => (
                    <li
                      className={cn(`${image?.id === img.id && styles.active}`)}
                      key={key}
                      onClick={() =>
                        setImage({ ...img, key, identef: "onboarding" })
                      }
                    >
                      <img
                        width="58"
                        height="144"
                        src={img.url.small}
                        loading="lazy"
                        alt="alt"
                      />
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        )}
      </div>
      <DownloadScreensModal show={showModal} setShow={setShowModal} />
    </>
  );
}
